<ng-container *ngIf="!sharelink && !spotlightlink && !draftLink">
<ng-container *ngIf="item && item.status && item.status == 'inactive'">
    <a [routerLink]="this.href" [queryParams]="{ isAdmin: 1 }"  class="text-blue-light">{{value}}</a>
</ng-container>
<ng-container *ngIf="item && item.status && item.status != 'inactive'">
    <a [routerLink]="this.href"  class="text-blue-light">{{value}}</a>
</ng-container>

<ng-container *ngIf="item && !item.status">
    <a [routerLink]="this.href"  class="text-blue-light">{{value}}</a>
</ng-container>
</ng-container>
<ng-container *ngIf="sharelink && !spotlightlink && !draftLink">
    <a [href]="this.href" target="_blank" class="text-blue-light">{{value}}</a>
</ng-container>
<ng-container *ngIf="!sharelink && !draftLink && spotlightlink">
    <a [href]="this.href" target="_blank" class="text-blue-light">{{value}}</a>
</ng-container>

<ng-container *ngIf="!sharelink  && !spotlightlink && draftLink" >
    <a [href]="this.href" target="_blank" class="text-blue-light">{{value}}</a>
</ng-container>